import { APPOINTMENT_AMENDABLE_STATUSES } from 'features/order-tracker/store/sagas/services/helpers/constants';
import { CONTACT_US_INFO_TYPE } from 'features/order-tracker/utils/entries/contactUsInfoType';

// eslint-disable-next-line no-unused-vars
import { AppointmentStrategy } from './AppointmentStrategy';

export class AmendableAppointmentStrategy implements AppointmentStrategy {
  getInfoType = (
    appointment: common.EngineerAppointment,
    isAuthenticated: boolean,
    isAmendAppointmentEnabled: boolean,
  ): common.ContactUsInfo | null => {
    if (!isAmendAppointmentEnabled) {
      return CONTACT_US_INFO_TYPE.AmendmentDisabled;
    }
    if (appointment.isDateLessThan24Hours) {
      return CONTACT_US_INFO_TYPE.ForbidToAmend;
    }
    if (!isAuthenticated && isAmendAppointmentEnabled) {
      return CONTACT_US_INFO_TYPE.Amendable;
    }
    return null;
  };

  isReminderAvailable = (appointment: common.EngineerAppointment): boolean =>
    APPOINTMENT_AMENDABLE_STATUSES.includes(appointment.status);

  isSiteContactAvailable = (appointment: common.EngineerAppointment): boolean => !!appointment.siteContact;

  isAmendable = (
    appointment: common.EngineerAppointment,
    isAuthenticated: boolean,
    isAmendAppointmentEnabled: boolean,
  ): boolean => isAuthenticated && isAmendAppointmentEnabled && !appointment.isDateLessThan24Hours;

  isApplicable = (appointment: common.EngineerAppointment): boolean =>
    APPOINTMENT_AMENDABLE_STATUSES.includes(appointment.status);

  isHelpSectionAvailable = (): boolean => true;
}
